import { formProcessingActions, formProcessingGetters, formProcessingMutations, formProcessingState } from  '../../../../../Core/Global/Store/form-processing';

export const state = {
    ...formProcessingState,
    successModalVisible: false,
    message: null,
    response: null,
    formId: '#add-comment-form'
}

export const getters = {
    ...formProcessingGetters,
}

export const mutations = {
    ...formProcessingMutations,
    SET_SUCCESS_MODAL(state, data) {
        state.successModalVisible = data;
    },
    SET_MESSAGE(state, message) {
        state.message = message;
    },
    SET_RESPONSE(state, response) {
        state.response = response;
    }
}

export const actions = {
    ...formProcessingActions,
    submitForm({ commit, dispatch, getters}, payload) {
        let formActionUrl = '/condolence/store'

        //check if the form is valid
        dispatch('validateForm', `#${payload.target.id}`);

        if(getters.getFormIsValid){
            //set the form processing variable
            dispatch('setFormProcessing', true);
            let formData = new FormData(payload.target);

            if (!formData.has('is_private')) formData.append('is_private', 0);

            axios.post(formActionUrl, formData)
            .then(response => {
                //If successful
                if (response.status == 201 || response.status == 200) {
                    //Show success notification
                    commit('SET_MESSAGE',response.data.message);
                    commit('SET_RESPONSE','Success');
                    commit('SET_SUCCESS_MODAL',true);
                    //reset all form processing variables
                    dispatch('resetCondolenceForm', payload.target);
                    dispatch('resetAllFormProcessingValues');
                }
            }).catch(error => {
                const data = JSON.parse(error.request.responseText)
                let message ='';
                for (error in data[0]) {
                    message +=' '+data[0][error]
                }
                commit('SET_RESPONSE','Error');
                commit('SET_MESSAGE',message);
                commit('SET_SUCCESS_MODAL',true);
                //set the form processing variable
                dispatch('setFormProcessing', false);
            });
        }
    },
    resetCondolenceForm({ dispatch }, formEl){
        dispatch('clearFormValidation');
        formEl.reset();
    },
}

export default { namespaced: true, state, getters, mutations, actions };